module.exports = __webpack_public_path__ + "img/bg23.c78ca03c.jpg";